import Swal from 'sweetalert2';
import template from './OrderTermsModalComponent.html';

export default {
  template,

  data() {
    return {
      open: false,
    };
  },

  methods: {
    openModal() {
      this.open = true;

      Swal.fire({
        title: 'Salgsbetingelser',
        confirmButtonText: 'Lukk',
        showCloseButton: true,
        html: this.$el,
        grow: 'row',
        animation: false,
      }).finally(() => {
        this.open = false;
      });
    },
  },
};
